function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M114.759 512h61.103l-96.414-61.793-79.25-46.309C3.659 464.09 53.716 512 114.759 512z",
  fill: "#fde494"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M335.448 476.69l-69.006-17.655H114.759c-34.072 0-61.793-27.721-61.793-61.793v-33.876l-26.483-28.42L0 339.628v57.613c0 2.236.072 4.454.198 6.657L175.862 512h208.767l-49.181-35.31z",
  fill: "#fea150"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M441.655 440.14c-11.244 11.637-26.993 18.894-44.414 18.894H266.442L384.629 512h12.612c41.202 0 77.396-21.829 97.64-54.527l-27.022-16.094-26.204-1.239z",
  fill: "#ff5d4a"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M459.034 326.014v71.228c0 16.652-6.633 31.775-17.379 42.899l53.227 17.333C505.728 439.954 512 419.318 512 397.241v-62.805l-27.396-15.391-25.57 6.969z",
  fill: "#e45261"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff4d95",
  d: "M512 149.19l-28.203-6.716-24.763 14.826v168.714L512 334.436z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M512 114.759c0-57.633-42.708-105.473-98.136-113.55L344.43 30.101l-35.183 22.865h87.994c34.072 0 61.793 27.721 61.793 61.793V157.3L512 149.19v-34.431z",
  fill: "#cb319c"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M317.732 0L252.05 24.636l-51.805 28.33h109.002L413.864 1.208A115.22 115.22 0 00397.241 0h-79.509z",
  fill: "#8a3293"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M256 406.069c18.358 0 35.954-3.32 52.226-9.38l-86.02-39.047-91.178-18.657c26.918 40.405 72.885 67.084 124.972 67.084z",
  fill: "#ff5d4a"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M329.153 305.358c-15.883 23.465-42.748 38.918-73.153 38.918-40.273 0-74.308-27.118-84.867-64.046l-23.682-14.801-40.847 4.538a149.134 149.134 0 0024.425 69.017l177.198 57.705c38.303-14.264 69.237-43.757 85.458-81.068l-31.753-16.085-32.779 5.822z",
  fill: "#e45261"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  fill: "#ff4d95"
}, /*#__PURE__*/React.createElement("path", {
  d: "M167.724 256c0-21.878 8.018-41.907 21.247-57.346l-37.658-5.268-38.25 16.892A149.478 149.478 0 00105.931 256c0 4.712.244 9.365.671 13.966l64.53 10.262A87.974 87.974 0 01167.724 256zM406.069 256c0-32.138-10.159-61.946-27.428-86.39l-37.397-5.308-38.418 16.917c24.873 15.631 41.45 43.298 41.45 74.781 0 18.27-5.58 35.261-15.123 49.358l64.531 10.262A149.162 149.162 0 00406.069 256z"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  fill: "#cb319c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M256 167.724c17.194 0 33.242 4.959 46.826 13.495l75.815-11.609c-27.196-38.493-72.03-63.679-122.641-63.679-66.81 0-123.554 43.889-142.937 104.345l75.908-11.624c16.202-18.91 40.232-30.928 67.029-30.928zM397.241 150.069c19.47 0 35.31-15.84 35.31-35.31s-15.84-35.31-35.31-35.31c-19.47 0-35.31 15.84-35.31 35.31s15.84 35.31 35.31 35.31z"
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff5d4a",
  d: "M52.966 313.564L27.47 300.847 0 296.316v43.313l52.966 23.737z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#e45261",
  d: "M0 253.014v43.302l52.966 17.248v-52.127l-27.52-9.894z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff4d95",
  d: "M52.966 219.479l-27.217-.246L0 227.59v25.424l52.966 8.423z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#cb319c",
  d: "M52.966 179.757l-28.055 2.846L0 205.962v21.628l52.966-8.111z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#8a3293",
  d: "M0 205.962l52.966-26.205v-60.395L21.9 122.333 0 143.241z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M205.059 0L84.206 46.481 1.387 96.928A115.22 115.22 0 000 114.759v28.482l52.966-23.878v-4.605c0-34.072 27.721-61.793 61.793-61.793h85.487L317.732 0H205.059z",
  fill: "#523494"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M114.759 0C57.545 0 9.978 42.088 1.387 96.928L205.059 0h-90.3z",
  fill: "#2d2d87"
});

function SvgInstagramOriginal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    className: "w-full h-full"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

export default SvgInstagramOriginal;